import { render } from "./drayDetail.vue?vue&type=template&id=08c79e80"
import script from "./drayDetail.vue?vue&type=script&lang=js"
export * from "./drayDetail.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\e2efreight\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__